import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';


const staggeredGrid = function (options) {
    let o, m, masonryDefaults, internal, fn;


    o = $.extend({
        $e: null,
        selector: '',
        masonryOpts: {}
    }, options);


    m = staggeredGrid.markup;


    masonryDefaults = {
        itemSelector: `.${m.ITEM}`
    };


    internal = {
        $e: o.$e || $(o.selector),
        masonryOpts: Object.assign(masonryDefaults, o.masonryOpts),
        masonry: null
    };


    fn = {
        init () {
            imagesLoaded(internal.$e[0], function () {
                internal.masonry = new Masonry(internal.$e[0], internal.masonryOpts);
                internal.$e.addClass(m.SETUP);
            });
        },

        destroy () {
            internal.masonry.destroy();
            internal.$e.removeClass(m.SETUP);
        }
    };


    fn.init();
};


staggeredGrid.markup = {
    // dom selector
    CONTAINER: 'staggered',
    ITEM: 'staggered__item',

    // states
    SETUP: 'state-setup'
};


export default staggeredGrid;



// WEBPACK FOOTER //
// ./assets/js/components/staggered-grid.js